export default __webpack_public_path__ + "static/media/icon_contact.a1d6b56a.png";